(function () {
    "use strict";

    angular.module("app").component("habilLoadingOverlay", {
        templateUrl: '@/loadingOverlay/loading-overlay.html',
        bindings: {
            isLoading: '=?',
            label: '@'
        },
        controller: LoadingOverlayController
    });


    LoadingOverlayController.$inject = ['loadingIndicatorService'];
    function LoadingOverlayController(loadingIndicatorService) {
        const $controller = this;
        $controller.$onInit = initializeComponent;

        function initializeComponent() {
            loadingIndicatorService.RegisterOverlayListener(onLoadingChange);
        }

        function onLoadingChange(_event, isLoading) {
            $controller.isLoading = isLoading;
        }
    }
})();